import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';

import {IAppState} from '../../interfaces/app-state';
import {BaseLayoutComponent} from '../base-layout/base-layout.component';
import {HttpService} from '../../services/http/http.service';
import {IOption} from '../../ui/interfaces/option';
import {Content} from '../../ui/interfaces/modal';
import {TCModalService} from '../../ui/services/modal/modal.service';
import {IPatient} from '../../interfaces/patient';
import * as PatientsActions from '../../store/actions/patients.actions';
import * as SettingsActions from '../../store/actions/app-settings.actions';
import {UserService} from '../../services/user.service';
import {SupervisorsocketService} from '../../services/supervisorsocket.service';
import {UserType} from '../../services/CONST';
import {TranslateService} from '@ngx-translate/core';
import {BatchStatusComponent} from '../../pages/dialogs/batch-status/batch-status.component';
import {MatDialog} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {USSDGWSimulatorService} from '../../services/ussdgw-simulator.service';


@Component({
  selector: 'vertical-layout',
  templateUrl: './vertical.component.html',
  styleUrls: [
    '../base-layout/base-layout.component.scss',
    './vertical.component.scss'
  ]
})
export class VerticalLayoutComponent extends BaseLayoutComponent implements OnInit, OnDestroy {

  patientForm: FormGroup;
  languages: IOption[];
  gender: IOption[];
  currentAvatar: string | ArrayBuffer;
  defaultAvatar: string;
  @ViewChild('audioOption') audioPlayerRef: ElementRef;
  form;
  batch_subscriber = new Subscription();


  constructor(
    store: Store<IAppState>,
    fb: FormBuilder,
    httpSv: HttpService,
    router: Router,
    elRef: ElementRef,
    public user: UserService,
    private modal: TCModalService,
    private  supervisor_socket: SupervisorsocketService,
    private ussdgw_simulator_socket: USSDGWSimulatorService,
    public translate: TranslateService,
    public dialog: MatDialog
  ) {
    super(store, fb, httpSv, router, elRef);
    /*
    translate configs
     */
    // this.user.configDEfaultLang();
    /**
     * dropdowns values
     */
    this.gender = [
      {
        label: 'Male',
        value: 'male'
      },
      {
        label: 'Female',
        value: 'female'
      }
    ];

    this.languages = [
      {
        label: 'fr',
        value: 'fr',
        img: './assets/img/france.png'
      },
      {
        label: 'en',
        value: 'en',
        img: './assets/img/british.png'
      }
    ];
    this.defaultAvatar = 'assets/content/anonymous-400.jpg';
    this.currentAvatar = this.defaultAvatar;
  }

  ngOnInit() {
    super.ngOnInit();
    this.openBatchStatusDialog();
    this.form = this.fb.group({lang: this.user.defaultLng});

    this.user.getUserInfo().then(res => {
      this.user.initPendingTransactionDB();
      this.user.initNavigatorDB();
      this.user.processPendingTransactions();

      this.langChange();
      const type = this.user.authenticated.type;
      // console.log(this.supervisor_socket.connected);
      // console.log('user_type', type);
      if (!this.supervisor_socket.connected && type === UserType.SUPERVISOR) {
        this.supervisor_socket.supervisor_connect();
        if (this.supervisor_socket.supervisor_socket) {
          this.supervisor_socket.supervisor_socket.once('connect', (data) => {
            console.log('new supervisor_socket connection', data);
            this.user.user_event.next(true);
          });
        }
      }

      if (!this.supervisor_socket.connected && type === UserType.SUPERVISOR) {
        this.supervisor_socket.supervisor_connect();
        if (this.supervisor_socket.supervisor_socket) {
          this.supervisor_socket.supervisor_socket.once('connect', (data) => {
            console.log('new supervisor_socket connection', data);
            this.user.user_event.next(true);
          });
        }
      }

      if (!this.supervisor_socket.sim_connected && (type === UserType.SUPER_ADMIN || type === UserType.ADMIN)) {
        this.supervisor_socket.sim_socket_connect();

        if (this.supervisor_socket.sim_socket) {
          this.supervisor_socket.sim_socket.once('connect', (data) => {
            console.log('new sim supervisor_socket connection', data);
          });
        }

      }

      if (type === UserType.SUPER_ADMIN) {
        this.ussdgw_simulator_socket.ussdgw_simulator_connect();

        if (this.ussdgw_simulator_socket.ussdgw_simulator) {
          this.ussdgw_simulator_socket.listen('test').subscribe((data) => {
            console.log('oooooooooOOOOOOOOOOOOOOOOOOOOOOooooooooooo',data);
          });
        }

      }
    });



    this.store.dispatch(new SettingsActions.Update({layout: 'vertical'}));
  }

  // open modal window
  openModal<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, options: any = null) {
    this.initPatientForm();

    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
  }

  // close modal window
  closeModal() {
    this.modal.close();
    this.patientForm.reset();
    this.currentAvatar = this.defaultAvatar;
  }

  // upload new file
  onFileChanged(inputValue: any) {
    let file: File = inputValue.target.files[0];
    let reader: FileReader = new FileReader();

    reader.onloadend = () => {
      this.currentAvatar = reader.result;
    };

    reader.readAsDataURL(file);
  }

  // init form
  initPatientForm() {
    this.patientForm = this.fb.group({
      img: [],
      name: ['', Validators.required],
      number: ['', Validators.required],
      age: ['', Validators.required],
      gender: ['', Validators.required],
      address: ['', Validators.required]
    });
  }

  // add new patient
  addPatient(form: FormGroup) {
    if (form.valid) {
      const newPatient: IPatient = form.value;

      newPatient.img = this.currentAvatar;
      newPatient.id = '23';
      newPatient.status = 'Pending';
      newPatient.lastVisit = '';

      this.store.dispatch(new PatientsActions.Add(newPatient));
      this.closeModal();
      this.patientForm.reset();
    }
  }

  langChange() {
    this.form.get('lang').valueChanges.subscribe(val => {
      this.user.setLanguage(val);
      console.log(val);
    });
  }

  openBatchStatusDialog() {
    this.batch_subscriber = this.user.batch_event.subscribe(value => {
      // console.log(value);
      if (value) {
        const dialogRef = this.dialog.open(BatchStatusComponent, {
          width: '330px', height: 'auto', data: {...value}
        });
        this.launchDialog(dialogRef);
      }
    });

  }

  launchDialog(dialogRef) {
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result);
    });
  }

  ngOnDestroy(): void {
    this.batch_subscriber.unsubscribe();
  }

}
